module.exports = __webpack_public_path__ + "static/media/Years_Gamma.98286887.png";